export default function Contact() {
  return (
    <div className="font-cinzel relative isolate overflow-hidden text-center  place-items-center dark:bg-slate-900 py-12 sm:py-24 lg:py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
          <div className="max-w-xl lg:max-w-sm sm:pl-16">
            <h3 className="text-xl font-bold tracking-tight  px-5 sm:text-2xl">
              Free Consultation With An AIC Designated Appraiser:
            </h3>
            <p className="mt-4 text-lg leading-6 text-blue-500">
              Mushtaq Khan, <br /> CRA, P.App President, <br />
              Alpha Appraisals Inc.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-2 justify-center items-center text-center">
            <div className="flex-none rounded-md  bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500">
              <a href="tel:+1-416-450-2336" alt="Direct Office Number">
                Direct: (416)-450-2336{" "}
              </a>
            </div>
            <div className="flex-none rounded-md  bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500">
              <a href="tel:+1-905-794-6241">Office: (905)-794-6241 </a>
            </div>
            <div className="flex-none rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500">
              <a href="mailto:info@alphaappraisals.ca">
                Email : info@alphaappraisals.ca
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
